import { Check, Gift } from "lucide-react";
import { inr } from "@/lib/api";

export function VoucherItemPicker({ eligible, picked, onToggle }) {
  return (
    <div className="mt-2 rounded-2xl border-2 border-biga-green/20 bg-white p-3" data-testid="voucher-item-picker">
      <p className="text-xs font-bold text-biga-ink/60 flex items-center gap-1.5 mb-2"><Gift size={13} /> {eligible.length === 1 ? "Your free item" : "Pick your free item"}</p>
      <div className="flex flex-col gap-1.5">
        {eligible.map((line) => {
          const on = picked.includes(line.index);
          return (
            <button key={line.index} type="button" onClick={() => onToggle(line)} data-testid={`voucher-pick-${line.index}`}
              className={`flex items-center justify-between rounded-full px-3.5 py-2 text-sm font-semibold border-2 transition-colors ${on ? "border-biga-green bg-biga-green/10 text-biga-green" : "border-biga-ink/10 text-biga-ink/70 hover:border-biga-green/40"}`}>
              <span className="flex items-center gap-2">{on && <Check size={14} />}{line.name}</span>
              <span className="text-xs">{inr(line.unit_price)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
